import {Injectable, TemplateRef} from '@angular/core';
import {NzMessageService} from 'ng-zorro-antd/message';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class MessageAlertService {

  messages = {
    invalidCredentials: 'Usuario o contraseña incorrecta',
    emailAlreadyExist: 'El correo electrónico ya está en uso',
    userNotFound: 'El correo electrónico no existe en el sistema',
    incompleteData: 'Completar los campos que sean necesarios',
    scheduleNotAvailable: 'El horario que seleccionaste no está disponible para ese día',
    cannotAccessThisResource: 'No puedes acceder a este recurso',
    sessionExpired: 'Lo sentimos, la sesión ha expirado',
    patientNotFound: 'El paciente no existe',
    accessDenied: 'Acceso denegado'
  };

  abstractError = 'Ha ocurrido un error, intente más tarde';

  constructor(
    private message: NzMessageService
  ) {}

  createMessage(type: 'success' | 'error' | 'warning' | 'info', message: string, duration?: number): void {
    this.message.create(type, `${message}`, { nzDuration: duration !== void 0 ? duration : 3000});
  }

  createTemplateMessage(type: 'success' | 'error' | 'warning', tpl: TemplateRef<void>, duration?: number): void {
    this.message.create(null, tpl, {
      nzDuration: duration !== void 0 ? duration : 3000,
    });
  }

  getMessageError(key): string {
    key = _.camelCase(key);
    let messageError = this.messages[key];
    if (!messageError) {
      messageError = this.abstractError;
    }
    return messageError;
  }
}
